module.exports = __webpack_public_path__ + "static/media/furnished1.f1d4467e.svg";